module.exports = __webpack_public_path__ + "img/rw.83f616f2.jpg";